// Multi-tenancy Phase 4b — applies the tenant's public face at boot.
// Branding keys (all optional; absent keys keep the built-in Iter look, the
// CSS falls back via var(--brand-*, <default hex>)):
//   primaryColor / secondaryColor / accentColor — palette
//   favicon — URL; name — browser title; logo — read by components via
//   getBranding().
const CSS_VARS = {
  primaryColor: "--brand-primary",
  secondaryColor: "--brand-secondary",
  accentColor: "--brand-accent",
};

export const injectTheme = (config) => {
  if (!config) return;
  const branding = config.branding || {};
  const root = document.documentElement;

  Object.entries(CSS_VARS).forEach(([key, cssVar]) => {
    if (branding[key]) root.style.setProperty(cssVar, branding[key]);
  });

  if (config.name) document.title = config.name;

  if (branding.favicon) {
    let link = document.querySelector('link[rel="icon"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = branding.favicon;
  }
};
